import { Portfolio, Rebalance } from './model.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from "rxjs";
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { STATUS_CONSTANTS } from "../services/STATUS_CONSTANTS";
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
import { LocalStorageService } from 'ngx-store';
import { Router, ActivatedRoute } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import Swal from 'sweetalert2'
const headers = new HttpHeaders().set(InterceptorSkipHeader, '');

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class RemoteService {
  url: string;
  interval: any;
  sessionIsShow: boolean = false;
  helper = new JwtHelperService();
  isShowSpinner: boolean = true;
  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    private notifierService: NotifierService,
    public ls: LocalStorageService,
    public router: Router,
    private route: ActivatedRoute) {
    this.url = environment.url;
  }

  /** Portfolio and Stocks Services */

  addPortfolio(portfolio: Portfolio, successFn, errorFn) {
    this.http.post(this.url + 'portfolio', portfolio, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  editPortfolio(portfolio: Portfolio, successFn, errorFn) {
    const PortfolioObj = {
      portfolioId: portfolio.portfolioId,
      name: portfolio.name,
      description: portfolio.description,
      allocatedCash: portfolio.allocatedCash,
      investor: portfolio.investor,
      stocks: portfolio.stocks
    };

    this.http.put(this.url + 'portfolio', PortfolioObj, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  deletePortfolio(portfolioId, successFn, errorFn) {
    this.http.delete(this.url + 'v1/portfolio/' + portfolioId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getAllPortfolio(successFn, errorFn) {
    this.http.get(this.url + 'v1/admin/portfolio/all', { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getAllPortfolioByInvestorId(investorId, successFn, errorFn) {
    this.http.get(this.url + 'v1/portfolio/investor/' + investorId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getPortfolioById(portfolioId, successFn, errorFn) {
    this.http.get(this.url + 'v1/portfolio/' + portfolioId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getPortfolioStocks(portfolioId, successFn, errorFn) {
    const paramsObj = new HttpParams().set('portfolioId', portfolioId);
    this.http.get(this.url + 'v1/portfolio/stock', { responseType: 'text', params: paramsObj })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getAllPortfolioStocks(successFn, errorFn) {
    this.http.get(this.url + 'v1/portfolio/stock/', { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getAllRegisterdStocks(query): Observable<any> {
    const paramsObj = new HttpParams().set('searchString', query.searchString).set('pageIndex', query.index).set('pageSize', query.size);
    return this.http.get(this.url + 'v1/stock/registered', { params: paramsObj })
  }

  getStockResponseValidorNot(query): Observable<any> {
    const paramsObj = new HttpParams().set('symbol', query.symbol).set('exchange', query.exchange).set('fetchData', query.fetchData);
    return this.http.get(this.url + 'v1/stock/is-valid-stock',
      { params: paramsObj });
  }

  getExchangeList(query): Observable<any> {
    const paramsObj = new HttpParams().set('searchString', query.searchString).set('pageIndex', query.index).set('pageSize', query.size);
    return this.http.get(this.url + 'exchange', { params: paramsObj });
  }


  updateNewStock(query): Observable<any> {
    return this.http.put(this.url + 'v1/stock/update-stock' + '?exchange=' + query.exchange + '&' + 'symbol=' + query.symbol, { responseType: 'text' });
  }

  getAllPortfolioInvestors(successFn, errorFn) {
    this.http.get(this.url + 'v1/investor/', { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getTotalInvestment(portfolioId): Observable<any> {
    return this.http.get(this.url + 'v1/portfolio/total-investment/' + portfolioId);
  }

  /** Rebalance services */

  addRebalance(rebalance: Rebalance, successFn, errorFn) {
    const RebalanceObj = JSON.parse(JSON.stringify(rebalance));
    RebalanceObj.rebalanceStocks.forEach(rbstk => {
      delete rbstk.stock.priceLastUpdate;
      delete rbstk.stock.quantityLastUpdate;
    });

    this.http.post(this.url + 'v1/portfolio/rebalance/relative', RebalanceObj, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  updateRebalance(rebalanceSummaryId, successFn, errorFn) {
    this.http.put(this.url + 'v1/portfolio/rebalance/trade/' + rebalanceSummaryId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getRebalanceByPortfolioId(portfolioId, successFn, errorFn) {
    this.http.get(this.url + 'v1/portfolio/rebalance/' + portfolioId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getPortfolioPriceForGraphSorting(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('totalDays', query.totalDays).set('groupBy', query.groupBy);
    return this.http.get(this.url + 'v1/graph/portfolio',
      { params: paramsObj });
  }

  getPortfolioRemainingCash(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('date', query.date).set('currency', query.currency);
    return this.http.get(this.url + 'v1/portfolio/current-portfolio-balance',
      { params: paramsObj });
  }

  getPortfolioCashTransaction(query): Observable<any> {
    var paramsObj;
    if (query.fromDate === null && query.toDate === null) {
      paramsObj = new HttpParams().set('portfolioId', query.portfolioId);
    } else if (query.fromDate === null || query.fromDate === '' || query.fromDate === undefined) {
      paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('endDate', query.toDate);
    } else if (query.toDate === null || query.toDate === '' || query.toDate === undefined) {
      paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('startDate', query.fromDate);
    } else {
      paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('startDate', query.fromDate).set('endDate', query.toDate);
    }

    if (query.currency === null || query.currency === '' || query.currency === undefined) {
      query.currency = 'CAD';
    }
    paramsObj = paramsObj.set('currency', query.currency);
    return this.http.get(this.url + 'v1/portfolio/portfolio-cash-transactions',
      { params: paramsObj });
  }

  portfolioDeposit(payload): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/portfolio-deposit', payload);
  }

  portfolioWithdraw(payload): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/portfolio-withdraw', payload);
  }

  transferMoneyToPortfolio(payload): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/cash-transfer', payload);
  }

  /** Investor Services */

  getInvestorByInvestorId(investorId, successFn, errorFn) {
    this.http.get(this.url + 'v1/investor/' + investorId, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getInvestors(successFn, errorFn) {
    this.http.get(this.url + 'v1/admin/investor/all/', { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  /** Stocks Services */

  getStockByInvestorAndStockId(investorId, stockId, successFn, errorFn) {
    const paramsObj = new HttpParams().set('investorId', investorId).set('stockId', stockId);
    this.http.get(this.url + 'portfolio/search/stocks', { responseType: 'text', params: paramsObj })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  login(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/login', payload, { headers });
  }

  cashRequestForDeposit(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/deposit-amount', payload);
  }

  cashRequestForWithdraw(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/withdraw-amount', payload);
  }

  signup(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/signup', payload, { headers });
  }

  deleteUser(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/delete-my-account', payload, httpOptions);
  }

  subscribeEmail(payload): Observable<any> {
    return this.http.post(this.url + 'v1/subscribe', payload, { headers });
  }

  verifySignup(token): Observable<any> {
    const paramsObj = new HttpParams().set('jwtToken', token);
    return this.http.get(this.url + 'v1/auth/verify-signup', { params: paramsObj, headers })
  }

  verifyRestoreAccount(token): Observable<any> {
    const paramsObj = new HttpParams().set('jwtToken', token);
    return this.http.get(this.url + 'v1/auth/verify-restore-my-account', { params: paramsObj, headers })
  }

  logout(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/signout', payload, httpOptions);
  }

  forgotPassword(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/user/forgot-password', payload, { headers });
  }

  restoreRequestMail(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/restore-my-account', payload, { headers });
  }

  changePassword(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/user/set-password', payload, { headers });
  }

  getAccessingRole(payload): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/is-admin', payload);
  }

  getRefreshToken(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/refresh-token', payload, httpOptions);
  }

  updateUserDetails(payload, successFn, errorFn) {
    this.http.put(this.url + 'v1/auth/user', payload)
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getCountriesList(query): Observable<any> {
    const paramsObj = new HttpParams().set('searchString', query.searchString).set('pageIndex', query.pageIndex).set('pageSize', query.pageSize);
    return this.http.get(this.url + 'v1/country-exchange/countries', { headers, params: paramsObj });
  }

  getCountryBasedOnExchangeSymbol(query): Observable<any> {
    return this.http.get(this.url + 'v1/country-exchange/country/' + query, { responseType: 'text' });
  }

  getCountryExchangeList(query): Observable<any> {
    const paramsObj = new HttpParams().set('country', query);
    return this.http.get(this.url + 'v1/country-exchange/exchanges',
      { responseType: 'text', params: paramsObj, headers });
  }

  getUserDetailsByUsingEmail(query): Observable<any> {
    return this.http.get(this.url + 'v1/auth/user/email/' + query);
  }

  getInvestorDetailsByUsingEmail(emailId, successFn, errorFn) {
    const paramsObj = new HttpParams().set('emailId', emailId);
    this.http.get(this.url + 'v1/investor/email',
      { responseType: 'text', params: paramsObj })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  /**********   add holdings   ***********/

  saveTrade(payload): Observable<any> {
    return this.http.post(this.url + 'v1/trade', payload)
  }

  deleteTrade(payload): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: payload
    };
    return this.http.delete(this.url + 'v1/portfolio/stock', options)
  }

  getPerticularTrade(tradeId): Observable<any> {
    return this.http.get(this.url + 'v1/stock/' + tradeId)
  }

  getStockDetailByUsingSymbol(query): Observable<any> {
    if (query.date == null) {
      var paramsObj = new HttpParams().set('symbolAndExchange', query.symbolAndExchange);
    } else {
      var paramsObj = new HttpParams().set('symbolAndExchange', query.symbolAndExchange).set('date', query.date);
    }
    return this.http.get(this.url + 'v1/stock/symbol',
      { responseType: 'text', params: paramsObj });
  }

  addStockToPortfolio(payload, successFn, errorFn) {
    this.http.post(this.url + 'v1/portfolio/stock', payload, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          successFn(response);
        },
        (error: any) => {
          errorFn(error);
        }
      );
  }

  getTradesList(query): Observable<any> {
    var paramsObj = new HttpParams().set('stockId', query.stockId).set('isSplitReqiured', query.isSplitReqiured);
    return this.http.get(this.url + 'v1/trade/stock', { params: paramsObj })
  }

  updateTrade(payload): Observable<any> {
    return this.http.put(this.url + 'v1/trade', payload)
  }
  deleteParticularTrade(tradeId): Observable<any> {
    return this.http.delete(this.url + 'v1/trade/' + tradeId)
  }

  hasReachedMaxStockCount(id): Observable<any> {
    return this.http.get(this.url + 'v1/portfolio/max-stock/'+ id)
  }

  /****************** create portfolio ******************** */

  getAllStocks(): Observable<any> {
    return this.http.get(this.url + 'portfolio/stocks')
  }

  createPortfolio(payload): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio', payload);
  }

  updatePortfolio(payload): Observable<any> {
    return this.http.put(this.url + 'v1/portfolio', payload);
  }

  /**    end   **/

  /****************** spinner ******************** */

  showSpinner() {
    this.spinner.show();
  }

  hideSpinner() {
    this.spinner.hide();
  }

  /** end **/

  /**********   newsletter start   ***********/

  newsletterSubscriptionRequest(query): Observable<any> {
    return this.http.post(this.url + 'newsletter-subscription-request', query);
  }

  newsletterSubscriptionConfirm(query): Observable<any> {
    return this.http.post(this.url + 'newsletter/confirm-subscription', query);
  }

  newsletterSubscriptionCancel(query): Observable<any> {
    return this.http.post(this.url + 'newsletter/cancel-subscription', query);
  }

  confirmCancelnewsletterSubscription(query): Observable<any> {
    return this.http.post(this.url + 'newsletter/confirm-cancel-newsletter', query);
  }

  /**********   newsletter end   ***********/

  /**capital gain */

  capitalGain(portfolioId): Observable<any> {
    return this.http.get(this.url + 'v1/capital-gain/portfolio/' + portfolioId)
  }

  capitalGainBasedOnStock(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('stockId', query.stockId);
    return this.http.get(this.url + 'v1/capital-gain/stock', { params: paramsObj })
  }

  totalCapitalGains(userId): Observable<any> {
    return this.http.get(this.url + 'v1/capital-gain/user/' + userId)
  }

  /** graph services*/

  getStockPriceForGraphBasedOnInstrumentId(query): Observable<any> {
    const paramsObj = new HttpParams().set('instrumentId', query);
    return this.http.get(this.url + 'v1/graph/stock-price',
      { params: paramsObj });
  }

  getStockPriceForGraphSorting(query): Observable<any> {
    const paramsObj = new HttpParams().set('instrumentId', query.instrumentId).set('durationType', query.durationType).set('stockId', query.stockId);
    return this.http.get(this.url + 'v1/graph/stock-price/duration',
      { params: paramsObj });
  }

  getInstrumentDetails(instrumentId): Observable<any> {
    return this.http.get(this.url + 'v1/sector/instrument/' + instrumentId);
  }

  getSMAGraphDetails(query): Observable<any> {
    const paramsObj = new HttpParams().set('symbol', query.symbol).set('interval', query.interval).set('time_period', query.time_period).set('series_type', query.series_type).set('apikey', query.apikey).set('item_count', query.item_count);
    return this.http.get(this.url + 'technical-analytic/sma',
      { params: paramsObj });
  }

  getSectorList(): Observable<any> {
    return this.http.get(this.url + 'v1/sector/all');
  }

  getIndustryList(query): Observable<any> {
    const paramsObj = new HttpParams().set('sector', query);
    return this.http.get(this.url + 'v1/sector/industry', { params: paramsObj });
  }

  getStocksBasedOnIndustry(query): Observable<any> {
    const paramsObj = new HttpParams().set('industry', query);
    return this.http.get(this.url + 'company-overview', { params: paramsObj });
  }

  getIndustryAndSectorBasedOnExchangeandSymbol(query): Observable<any> {
    const paramsObj = new HttpParams().set('symbol', query.symbol).set('exchange', query.exchange);
    return this.http.get(this.url + 'company-overview', { params: paramsObj });
  }
  /** exchange rate start */


  getExchangeRateConvert(query): Observable<any> {
    const paramsObj = new HttpParams().set('exchangeRateDate', query.exchangeRateDate).set('convertFromCurrencyCode', (query.convertFromCurrencyCode).toLowerCase()).set('convertToCurrencyCode', (query.convertToCurrencyCode).toLowerCase());
    return this.http.get(this.url + 'v1/convert-exchange-rate',
      { params: paramsObj });
  }

  /** exchange rate end */

  /**currency gain start*/

  currencyGainForPortfolio(portfolioId): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', portfolioId);
    return this.http.get(this.url + 'v1/currency-gain/portfolio',
      { params: paramsObj });
  }

  currencyGainForStocks(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('stockId', query.stockId);
    return this.http.get(this.url + 'v1/currency-gain/stock',
      { params: paramsObj });
  }

  /**currency gain end*/

  /**re balance start*/

  getWeightageOfThePortfolio(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query);
    return this.http.get(this.url + 'v1/sharperatio/portfolio',
      { params: paramsObj });
  }

  getRebalanceQuantity(query): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/rebalance', query);
  }

  addTradesToRebalanceSummary(query): Observable<any> {
    return this.http.post(this.url + 'v1/portfolio/rebalance/rebalance-summary', query);
  }

  getRebalanceSummaryDetails(summaryId): Observable<any> {
    return this.http.get(this.url + 'v1/portfolio/rebalance/history/' + summaryId);
  }

  /**re balance end*/

  /**start dividend */
  addDividend(query): Observable<any> {
    return this.http.post(this.url + 'v1/stock/dividend', query);
  }

  getDividends(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('symbol', query.symbol).set('pageIndex', query.pageIndex).set('pageSize', query.pageSize).set('exchange', query.exchange);
    return this.http.get(this.url + 'v1/stock/dividend', { params: paramsObj });
  }

  getOriginalDividends(query): Observable<any> {
    const paramsObj = new HttpParams().set('symbol', query.symbol).set('exchange', query.exchange).set('date', query.date).set('portfolioId', query.portfolioId);
    return this.http.get(this.url + 'v1/stock/original-dividend', { params: paramsObj });
  }

  updateDividend(query): Observable<any> {
    return this.http.put(this.url + 'v1/stock/dividend', query);
  }

  deleteDividend(id): Observable<any> {
    return this.http.delete(this.url + 'v1/stock/dividend/' + id);
  }

  dividendGainListForPortfolio(portfolioId): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', portfolioId);
    return this.http.get(this.url + 'v1/stock/get-portfolio-stock-dividends',
      { params: paramsObj });
  }

  dividendGainListForSpecificStock(query): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', query.portfolioId).set('stockSymbol', query.stockSymbol);
    return this.http.get(this.url + 'v1/stock/get-portfolio-stock-dividend',
      { params: paramsObj });
  }

  getTotalDividendGainForPortfolio(portfolioId): Observable<any> {
    const paramsObj = new HttpParams().set('portfolioId', portfolioId);
    return this.http.get(this.url + 'v1/stock/get-portfolio-dividend',
      { params: paramsObj });
  }
  /**end dividend */

  /**Admin start */

  getAllUsers(query): Observable<any> {
    const paramsObj = new HttpParams().set('searchString', query.searchString);
    return this.http.get(this.url + 'v1/admin/user/all', { params: paramsObj });
  }

  orphanPortfolioList(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/orphan-portfolios');
  }

  updateUserInAdmin(payload): Observable<any> {
    return this.http.put(this.url + 'v1/admin/user/' + payload.email, payload)
  }

  deleteUserInAdmin(email): Observable<any> {
    return this.http.delete(this.url + 'v1/admin/user/' + email);
  }

  unsubscribersUsersList(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/user-deleted/all');
  }

  unsubscribeRequestUsersList(query): Observable<any> {
    const paramsObj = new HttpParams().set('searchString', query);
    return this.http.get(this.url + 'v1/admin/Unsubscribed', { params: paramsObj });
  }

  unsubscribedUsersList(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/user-unsubscribed');
  }

  fetchBrokerCsv(payload): Observable<any> {
    return this.http.post(this.url + 'column_map', payload);
  }

  restoreUserDetails(payload): Observable<any> {
    return this.http.post(this.url + 'v1/admin/restore-user-account', payload);
  }

  getCashRequestedList(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/cash-requests');
  }

  updateMoneyRequest(payload, id): Observable<any> {
    return this.http.post(this.url + 'v1/admin/cash-Request-grant' + '?cashRequestId=' + id, payload);
  }

  updateRejectMoneyRequest(payload, id): Observable<any> {
    return this.http.post(this.url + 'v1/admin/reject-cash-request' + '?cashRequestId=' + id, payload);
  }

  adminNewsletterSubscriptionUsers(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/newsletter-subscribed-users');
  }

  adminNewsletterCancelUsers(): Observable<any> {
    return this.http.get(this.url + 'v1/admin/cancel-newsletter-users');
  }

  /**Admin end */

  /**Chat start */
  sendMessage(payload): Observable<any> {
    return this.http.post(this.url + 'post-message', payload);
  }
  /**Chat end */

  scrollingtoNavbar() {
    var element = document.getElementById("movingToNavBar");
    element.scrollIntoView();
  }

  errorFunction(error) {
    if (error.error.message) {
      this.notifierService.notify('error', error.error.message);
    } else {
      this.notifierService.notify('error', 'Something went wrong!');
    }
  }

  restart() {
  }

  isJsonError(err) {
    try {
      JSON.parse(err);
    } catch (e) {
      return false;
    }
    return true;
  }

  userNavigateTodashboard() {
    if (this.ls.get('access_token')) {
      if (this.helper.isTokenExpired(this.ls.get('access_token')) === false && this.helper.isTokenExpired(this.ls.get('refresh_token')) === false) {
        if (this.ls.get('role') == 'user') {
          return this.router.navigate(['/user/my-portfolios']);
        } else {
          return this.router.navigate(['/admin/admin-dashboard']);
        }
      } else {
        this.ls.clear();
        this.router.navigate(['/login']);
      }
    }
  }

  getAccesTokenInterval() {
    if (this.ls.get('access_token')) {
      this.interval = setInterval(() => {
        if (this.ls.get('access_token')) {
          const expirationDate = this.helper.getTokenExpirationDate(this.ls.get('tokenDetails').access_token);
          //@ts-ignore
          if (new Date(expirationDate) - new Date() < 715575) {
            this.getAccesToken();
          }
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    }
  }

  getAccesToken() {
    const payload = {
      "access_token": this.ls.get('tokenDetails').access_token,
      "before_policy": this.ls.get('tokenDetails').before_policy,
      "expires_in": this.ls.get('tokenDetails').expires_in,
      "id_token": "",
      "refresh_expires_in": this.ls.get('tokenDetails').refresh_expires_in,
      "refresh_token": this.ls.get('tokenDetails').refresh_token,
      "scope": this.ls.get('tokenDetails').scope,
      "session_state": this.ls.get('tokenDetails').session_state,
      "token_type": this.ls.get('tokenDetails').token_type,
      "user_name": this.ls.get('userName'),
      "user_roles": [
        this.ls.get('role')
      ]
    }
    this.isShowSpinner = false;
    this.getRefreshToken(payload).subscribe(res => {
      this.ls.set('access_token', res.access_token);
      this.ls.set('refresh_token', res.refresh_token);
      this.ls.set('tokenDetails', res);
    }, error => {
      clearInterval(this.interval);
      this.ls.clear();
      window.location.reload();
      this.errorFunction(error);
    })
  }

  openSweetAlert(data) {
    Swal.fire({
      text: data.text,
      icon: data.type,
      showCancelButton: false,
    }).then((result) => {
      if (data.link) {
        this.router.navigate([data.link], { relativeTo: this.route });
      }
    })
  }

  checkHoldingLimit(){
    this.hasReachedMaxStockCount(this.ls.get('editPortfolioId')).subscribe(res => {
      console.log(res)
      if(res){
        this.notifierService.notify('error', 'You have reached your holding limit');
      }
      else
        this.router.navigateByUrl('/user/add-holdings');
      
    });
  }

  unlockUser(payload): Observable<any> {
    return this.http.post(this.url + 'v1/auth/user/unlock', payload);
  }
}
